const StatusIcon = (props) => (
  <svg 
    width="12" 
    height="14" 
    viewBox="0 0 12 14" 
    fill="none"
    {...props} 
    className={`fill-current ${props?.className ? props?.className : ''}`} 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M6 0.5C6.64386 0.5 7.19754 0.916688 7.41016 1.50391L7.5293 1.83301H10.667C11.124 1.83319 11.5 2.20991 11.5 2.66699V12C11.5 12.4571 11.124 12.8328 10.667 12.833H1.33301C0.875964 12.8328 0.5 12.4571 0.5 12V2.66699C0.5 2.20991 0.875964 1.83319 1.33301 1.83301H4.4707L4.58984 1.50391C4.80246 0.916688 5.35614 0.5 6 0.5Z" 
      stroke={props?.fill || "currentColor"}
      strokeWidth="1"
      fill="none"
    />
    <path 
      d="M3.5 7L5.5 9L8.5 5.5" 
      stroke={props?.fill || "currentColor"}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default StatusIcon;
